"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyCustomDataCrfFile = exports.StudyCustomDataCrf = void 0;
class StudyCustomDataCrf {
}
exports.StudyCustomDataCrf = StudyCustomDataCrf;
class StudyCustomDataCrfFile {
}
exports.StudyCustomDataCrfFile = StudyCustomDataCrfFile;
//# sourceMappingURL=studyCustomDataCrf.js.map